import React from 'react'
import html from '../assets/html.png'
import css from '../assets/css.png'
import javascript from '../assets/javascript.jpg'
import react from '../assets/react.png'
import github from '../assets/github.png'
import tailwind from '../assets/tailwind.png'
import bootstrap from '../assets/bootstrap.png'
import firebase from '../assets/firebase.png'
import certificate from '../assets/certificate.png'
import next from '../assets/next.png'

const About = () => {
  return (
    <div className='w-full px-[5%] h-auto flex-col-reverse md:flex-row md:h-[800px] text-white 
    flex justify-around items-center mt-[50px] md:mt-0 mx-auto' id='about'>
      <div>
        <div className='w-full md:w-[500px]'>
        <h1 className='text-5xl font-bold my-4'>About me.</h1>
        <p>17 years old, Student. Interested in <span className='text-[#08f8f0]'>designing</span> and <span className='text-[#08f8f0]'>building </span> things from my learnings. <br /> <br /> My hobbies includes reading books, travelling and listening music. Loves to upskill myself by learning new things everyday. </p>
        <p className='my-10'>Technologies I've worked with:</p>
        </div>
        <div className="skills w-full md:w-[550px] flex flex-wrap justify-center items-center">
        <div className='mx-10 my-6 text-center'>
            <img className='w-20 my-4' src={html} alt="HTML" />
            <span className='mt-4 text-[#08f8f0]'>HTML</span>
        </div>
        <div className='mx-10 my-6 text-center'>
            <img className='w-20 my-4' src={css} alt="CSS" />
            <span className='mt-4 text-[#08f8f0]'>CSS</span>
        </div>
        <div className='mx-10 my-6 text-center'>
            <img className='w-20 my-4' src={javascript} alt="javascript" />
            <span className='mt-4 text-[#08f8f0]'>JavaScript</span>
        </div>
        <div className='mx-10 my-6 text-center'>
            <img className='w-20 my-4' src={react} alt="react" />
            <span className='mt-4 text-[#08f8f0]'>React</span>
        </div>
        <div className='mx-10 my-6 text-center'>
            <img className='w-20 my-4' src={bootstrap} alt="bootstrap" />
            <span className='mt-6 text-[#08f8f0]'>Bootstrap</span>
        </div>
        <div className='mx-10 my-6 text-center'>
            <img className='w-20 my-4' src={tailwind} alt="tailwind" />
            <span className='mt-6 text-[#08f8f0]'>Tailwind</span>
        </div>
        <div className='mx-10 my-6 text-center'>
            <img className='w-20 my-4 invert' src={github} alt="github" />
            <span className='mt-4 text-[#08f8f0]'>GitHub</span>
        </div>
        <div className='mx-10 my-6 text-center'>
            <img className='w-20 my-4' src={firebase} alt="firebase" />
            <span className='mt-4 text-[#08f8f0]'>Firebase</span>
        </div>
        <div className='mx-10 my-6 text-center'>
            <img className='w-20 my-4' src={next} alt="nextjs" />
            <span className='mt-4 text-[#08f8f0]'>NextJS</span>
        </div>
        </div>
      </div>
      <div>
        <img className='w-[300px]' src={certificate} alt="skills" />
      </div>
    </div>
  )
}

export default About
